/*global jQuery */
let mainNav = (function ($, window, document, undefined) {
  'use strict';

  let $window = $(window),
    $document = $(document),
    $mainNav = $('.js-mainNavigation');

  function updateAriaHidden() {
    if ($window.width() > 1248) {
      $mainNav.attr('aria-hidden', 'false');
    } else {
      if ($mainNav.hasClass('is-open')) {
        $mainNav.attr('aria-hidden', 'false');
      } else {
        $mainNav.attr('aria-hidden', 'true');
      }
    }
  }

  $window.on('resize', updateAriaHidden);
  $(updateAriaHidden);

  return {};

}(jQuery, window, document));
